export default __webpack_public_path__ + "static/media/ADVERTENCIA_TEST_DE_ANTIGENO.824e5914.pdf";